import React, { useState } from "react";
import MobileVerificationStyle from "./MobileVerification.style";
import { Box, Grid, Typography } from "@mui/material";
import CustomCard from "../../../../global/components/CustomCard/CustomCard";
import LogoIcon from "../../../../assets/icons/logo-icon.svg";
import CustomInput from "../../../../global/components/CustomInput/CustomInput";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as BackButtonIcon } from "../../../../assets/icons/ArrowLeft.svg";
import { Link } from "react-router-dom";
import OtpInput from "../../../../global/components/OtpInput/OtpInput";
import { useLocation } from "react-router-dom";
import { verifyOtp } from "./MobileVerificationService";
import { useAppDispatch } from "../../../../utils/hooks";
import { loginAction } from "../../../../redux/authSlice";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";
import customErrorHandler from "../../../../utils/customErrorHandler";
import notifiers from "../../../../global/constants/NotificationConstants";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";
import { motion } from "framer-motion";

const MobileVerification = ({ formFields }) => {
  const classes = MobileVerificationStyle;
  const [otp, setOtp] = useState("");

  const dispatch = useAppDispatch();
  const location = useLocation();
  const userIdFromLocation = location?.state?.userId;

  const mobileNumber = formFields?.email?.value?.substring(6, 9);

  const onChange = (value) => {
    return setOtp(value);
  };

  const verifyOtpCall = async () => {
    try {
      if (otp.length !== 6) throw { message: "Please enter complete opt" };
      const response = await verifyOtp(otp, userIdFromLocation);
      customErrorHandler(response);
      const { accessToken, fullName, role, _id, email } = response.data;
      dispatch(
        loginAction({
          authenticated: true,
          accessToken: accessToken,
          userName: fullName,
          email,
          role,
          userId: _id,
        })
      );
      openSuccessNotification(response.message);
    } catch (error) {
      if (customErrorHandler({}, error) === false) return;
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const cardContent = () => {
    return (
      <>
        <Box sx={classes.cardContentWrapper}>
          <Box sx={classes.cardHeader}>
            <img src={LogoIcon} alt="img" />
            <Typography sx={classes.cardTitle}>Mobile Verification</Typography>
            <Typography sx={classes.cardSubText}>
              {` 6 digit OTP verification sent on XXX XXX ${mobileNumber}`}
            </Typography>
          </Box>

          <Box sx={classes.cardContent}>
            <OtpInput
              value={otp}
              valueLength={6}
              onChange={onChange}
              formFields={formFields}
            />
          </Box>

          <Box sx={classes.cardFooter}>
            <CustomButton
              label="Verify"
              buttonType="primaryBtn"
              onClick={verifyOtpCall}
            />
            <Typography
              onClick={() => history.push(urls.forgotPasswordViewPath)}
              sx={classes.backToLogin}
            >
              Forgot Password?
            </Typography>
          </Box>
        </Box>
      </>
    );
  };

  const getMobileVerification = () => {
    return (
      <motion.div
        initial={{ scale: 0 }}
        animate={{
          scale: 1,
          transition: { duration: 0.8 },
        }}
      >
        <Box sx={classes.mainContentWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Box sx={classes.contentWrapper}>
                <CustomCard cardContent={cardContent()} />
                {/* <Box>
                  <Typography sx={classes.signUpStyle}>
                    Don't have an account? <Link to="/">Sign Up Now</Link>
                  </Typography>
                </Box> */}
              </Box>
            </Grid>
            <Grid
              item
              md={12}
              lg={12}
              position={"absolute"}
              bottom={"6px"}
              width={"100%"}
            >
              <Typography textAlign={"center"} sx={classes.disclamer}>
                © 2023, Yhataw Real Estate Facilitator. All Rights Reserved.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </motion.div>
    );
  };
  return getMobileVerification();
};

export default MobileVerification;
